export function initialize() {

    const handleHeroFormModLayout = () => {

        if (window.innerWidth < 1024) return;

        // ========================================================================
        // First, move the form upwards a bit — roughly 1/3 of the height of the
        // module's "top" area.
        // ========================================================================

        const heroFormTopEl = document.querySelector('#hero-form__top');

        if (!heroFormTopEl) return;

        const heroFormTopElHeight = heroFormTopEl.offsetHeight;
        const heightReduced       = heroFormTopElHeight / 3;

        document.documentElement.style.setProperty('--hero-form-top-position', '-' + heightReduced + 'px');

        // ========================================================================
        // Second, account for a scenario where the module's lower-left content
        // area is shorter than the form itself. Compare some heights, then
        // increase the height of the lower-left content area if needed … after
        // waiting a short period of time (to allow the form to render).
        // ========================================================================
        setTimeout(() => {
            const heroFormBottomEl       = document.querySelector('#hero-form__bottom');
            const heroFormBottomElHeight = heroFormBottomEl.offsetHeight;
            const formHeight             = document.querySelector('#hero-form__form').offsetHeight;

            if (formHeight > heroFormBottomElHeight) {
                const bottomPaddingY = parseInt(window.getComputedStyle(heroFormBottomEl).paddingTop) + parseInt(window.getComputedStyle(heroFormBottomEl).paddingBottom);
                const newBottomHeight = (formHeight - heightReduced) + bottomPaddingY;

                heroFormBottomEl.style.height = newBottomHeight + 'px';
            }
        }, 500);

    }

    window.addEventListener('load', () => {
        handleHeroFormModLayout();
    });

}
